import I18n from 'I18n';
import { formatDuration } from './durationFormatter';
import { formatIntlCurrency } from 'I18n/utils/formatIntlCurrency';
import { MILLISECONDS } from '../constants/timeUnits';
const FALLBACK = '–';
const DEFAULT_PRECISION = 2;
const withFallback = (format, coerce = Number) => (value, ...rest) => {
  const coercedValue = coerce(typeof value === 'string' ? value.replace(/,/g, '') : value);
  if ([null, undefined, ''].includes(value) ||
  // TODO remove following line - Typescript is erroring because the types
  // make the call impossible
  // @ts-expect-error legacy redundant call
  [null, undefined].includes(coercedValue) || !isFinite(coercedValue)) {
    return FALLBACK;
  }
  return format(coercedValue, ...rest);
};
const getPrecision = (value, customPrecision) => !customPrecision && Number(value) % 1 === 0 || customPrecision === 0 ? 0 : customPrecision || DEFAULT_PRECISION;
export const number = withFallback((value, options = {}) => {
  return I18n.formatNumber(value, Object.assign({
    precision: getPrecision(value, options.customPrecision),
    strip_insignificant_zeros: !options.keepInsignificantZeros
  }, options));
});

//TODO: add strip_insignificant_zeros: !keepInsignificantZeros after https://git.hubteam.com/HubSpot/I18n/issues/1152
export const percent = withFallback((value, options = {}) => I18n.formatPercentage(value, Object.assign({
  precision: getPrecision(value, options.customPrecision)
}, options)));

//TODO: add strip_insignificant_zeros: !keepInsignificantZeros after https://git.hubteam.com/HubSpot/I18n/issues/1152
export const currency = withFallback((value, options = {}) => {
  const {
    currencyCode
  } = options;
  return currencyCode ? formatIntlCurrency(value, Object.assign({
    precision: options.customPrecision,
    parts: options.delimiter && typeof options.delimiter === 'string' ? {
      group: options.delimiter
    } : undefined
  }, options)) : number(value, Object.assign({}, options, {
    maxFractionDigits: options.maximumFractionDigits
  })); // I18n.formatNumber accepts maxFractionDigits instead of maximumFractionDigits
});
export const duration = withFallback((value, {
  durationUnit = MILLISECONDS,
  smallScale = false,
  durationPrecision = 1,
  minimumDisplayUnit
} = {}) => {
  return formatDuration(I18n.moment.duration(value, durationUnit), smallScale, durationPrecision, durationUnit, minimumDisplayUnit);
});